import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-944c21a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { computed } from 'vue';

// 参考文档：https://swiperjs.com/vue#swiper-props
import { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
  __name: 'Swiper',
  props: {
    customClass: {
      type: String,
      default: ''
    },
    settings: {
      type: Object,
      default: () => {}
    },
    height: {
      type: String,
      default: ''
    },
    swiperList: {
      // [{imgUrl: '',.....}]
      type: Array,
      default: () => [{
        imgUrl: ''
      }],
      required: true
    }
  },
  emits: ['pushEvent'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const isM = window.sfe.isMobile || window.sfe.isApp;
    const DEFAULT_SETTINGS = {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: false,
      'slides-per-view': '1',
      // 轮播到最后一张时，下一张将会过度到第一张
      loop: true,
      pagination: {
        clickable: true
      },
      allowTouchMove: !!isM // pc不使用tocuhMoves事件
    };

    // eslint-disable-next-line
    const settings = computed(() => ({
      ...DEFAULT_SETTINGS,
      ...props.settings
    }));

    // 需要增加modules手动去添加
    const modules = [Pagination, Autoplay];
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Swiper), _mergeProps({
        class: ["spot-swiper-container", props.customClass],
        modules: modules
      }, {
        ..._unref(settings)
      }), {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.swiperList, (item, i) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: i,
            onClick: $event => {
              emits('pushEvent', item);
            }
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: item?.imgUrl,
              class: "swiper-img"
            }, null, 8, _hoisted_1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      }, 16, ["class"]);
    };
  }
};